import RouteImporter from '@/fragments/forms/route-importer/RouteImporter.vue'
import MapFormBtn from '@/fragments/forms/map-form-btn/MapFormBtn.vue'
import constants from '@/resources/constants'
import appConfig from '@/config/app-config'
import Download from '@/fragments/forms/map-form/components/download/Download'
import MapViewData from '@/models/map-view-data'
import { truncate } from 'lodash'

export default {
  data: () => ({
    items: ['1', '2', '3', '4', '5'],
    isDanger: false,
    devicecheck: false,
    orientationCheck : false,
    hostport: false,
    

  }),
  props: {
    // Amount of place inputs
    placeInputs: {
      required: true,
      type: Number
    },
    mapViewData: {
      Type: MapViewData,
      Required: true
    },
    // Amount of place inputs
    disabledActions: {
      default: () => [],
      type: Array
    }
  },
  mounted() {
    this.setListeners()
  },
  components: {
    RouteImporter,
    MapFormBtn,
    Download
  },
  computed: {
    /**
     * Determines if a place input can be added to the view
     * @returns boolean
     */
    canAddPlaceInput() {
      return this.placeInputs < appConfig.maxPlaceInputs
    },
    roundtripActive() {
      return this.$store.getters.mode === constants.modes.roundTrip
    }
  },
  methods: {
    isEnabled(action) {
      const disabled = this.disabledActions
      if (disabled.includes(action)) {
        return false
      }
      return true
    },
    /**
     * Toggle round trip
     */
    toggleRoundTrip() {
      this.$emit('toggleRoundTrip')
    },
    dangeruousValue(value) {
      var data_obj = {
        'value': value,
        'check_poligone': this.isDanger
      }
      localStorage.setItem('getpoint', value)
      this.eventBus.$emit('testp', data_obj);
    },
    /**
     * Add a place input
     */
    polygonsDengers() {
      this.isDanger = !this.isDanger
      this.eventBus.$emit('polygonsDenger', this.isDanger)
    },
    addPlaceInput() {
      this.$emit('addPlaceInput')
    },
    geojsonfileimport() {
      this.eventBus.$emit('geofileimport')
    },
    /**
     * Reset the places input to its default status (only one empty input)
     */
    clearPlaces() {
      this.$emit('clearPlaces')
    },
    /**
     * Reverse the route places
     */
    reverseRoute() {
      this.$emit('reverseRoute')
    },
    contentUploaded(data) {
      this.$emit('contentUploaded', data)
    },
    setListeners() {
      const context = this
      this.eventBus.$on('clearPlaces', context.clearPlaces)
    },
    iosPermission() {
      DeviceOrientationEvent.requestPermission()
        .then((response) => {
          if (response === "granted") {
            window.addEventListener("deviceorientation", handler, true);
          } else {
            alert("has to be allowed!");
          }
        })
        .catch(() => alert("not supported"));
    },
    deviceCheck() {
      const isIOScheck =
        navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
        navigator.userAgent.match(/AppleWebKit/);
      if (isIOScheck) {
        this.devicecheck = true
      }
    },
    hostportShow () {
      if(document.getElementsByClassName('custom-html-icon-div').length > 0) {
        let hostport = document.getElementsByClassName('custom-html-icon-div').length
        for (let index = 0; index < hostport; index++) {
          document.getElementsByClassName('custom-html-icon-div')[index].setAttribute("style", "display:block");
          
        }
      }
    }
  },
  created() {
    this.deviceCheck()
    this.setListeners();
    this.dangeruousValue('3')
  }
}
